import type { PropsWithChildren } from "react";
import { useMemo, useState } from "react";

import noop from "lodash/noop";

import type { ModalPath } from "@/constants/Navigation";
import { ModalTrackerContext } from "@/hooks/useModalTracker";

// on web, no native-specific concerns exist as web is not device-native
// however, this provider also sets/gets native-unrelated activeModal, whose logic is preserved
const SafeNativeModalProvider = ({ children }: PropsWithChildren) => {
  const [activeModal, setActiveModal] = useState<null | ValueOf<
    typeof ModalPath
  >>(null);

  const contextValue = useMemo(
    () => ({
      activeModal,
      allowNativeModalsAfterDelay: noop,
      allowNativeModalsImmediate: noop,
      isSafeToRenderNativeModals: true,
      preventNativeModals: noop,
      setActiveModal,
    }),
    // while this object will update as its dependencies change,
    // having its dependencies be stable useCallbacks prevents unnecessary re-renders
    // of things that depend on those callbacks downstream
    [activeModal, setActiveModal],
  );

  return (
    <ModalTrackerContext.Provider value={contextValue}>
      {children}
    </ModalTrackerContext.Provider>
  );
};

export default SafeNativeModalProvider;
